import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, TextField, DialogActions, Button, CircularProgress, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles.module.css';
import { AlertMessagesContext } from 'react-alert-messages';
import ChargeServices from 'services/ChargeServices';

export default function ChargeGroupCreateDialog({ handleClose, handleSuccess }) {
  const { t: tCommon } = useTranslation('common');
  const [data, setData] = useState({ name: '' });
  const [isLoading, setLoading] = useState(false);
  const { postAlertMessage } = useContext(AlertMessagesContext);
  const handleCreateChargeGroup = async () => {
    setLoading(true);
    try {
      const resp = await ChargeServices.createChargeGroup(data);
      postAlertMessage({ type: 'success', text: `Charge group created successfully.` });
      handleSuccess(resp);
      handleClose();
    } catch (err) {
      postAlertMessage({ type: 'error', text: err.message || 'Failed to create charge group.' });
    }
    setLoading(false);
  };

  return (
    <>
      <div className={styles.popUp}>
        <div className={styles.contentWrapper}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>{tCommon('Create Charge Group')}</h2>
            <IconButton onClick={handleClose} edge="end"><CloseIcon/></IconButton>
          </div>

          <div className={styles.inputSec}>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Charge group name')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  label={tCommon('Name')}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={data.name}
                  onChange={(e) => setData({ ...data, name: e.target.value })}
                />
              </Grid>
            </Grid>

            <DialogActions>
              <Button variant="contained" color="secondary" size="small" onClick={handleClose} disabled={isLoading}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ backgroundColor: '#00a65a' }}
                disabled={!data.name.trim() || isLoading}
                onClick={handleCreateChargeGroup}
              >
                {isLoading ? (
                  <>
                    <CircularProgress size={20} color="inherit" style={{ marginRight: '10px' }} />
                    {tCommon('Creating...')}
                  </>
                ) : (
                  tCommon('Create')
                )}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
    </>
  );
}
